export const TimeSpentEndpoints = {
  batchLogTimeSpent: process.env['NEXT_PUBLIC_API'] + '/time-spent/batch',
};
